import { useSearchParams } from "react-router-dom";

import { makeRequest } from "../../utils/request";
import { RestList, View } from "../../components/base";
import { User } from "../../redux/reducers/userSlice";

type AdminUsersPageProps = {
  className?: string;
};

export const AdminUsersPage = ({ className }: AdminUsersPageProps) => {
  const [searchParams] = useSearchParams();
  const isPanelOpen = searchParams.has("id");

  const search = async (query: string) => {
    try {
      const { data } = await makeRequest<{ data: User[] }>(`/v1/users/search?q=${query}`);
      return data.map((user) => user.id);
    } catch (error) {
      console.error("Error searching users:", error);
    }
    return [];
  };

  return (
    <View className="h-full w-full bg-gray-50 dark:bg-slate-900">
      <div className={`h-full w-full relative ${isPanelOpen ? "pr-[400px]" : ""} transition-all duration-300`}>
        <RestList
          className={`h-full w-full ${className || ""}`}
          entityName="user"
          search={search}
          hideCreate
          fields={[
            {
              name: "id",
              label: "ID",
              readOnly: true,
            },
            {
              name: "organizationId",
              label: "Organization Id",
              readOnly: true,
            },
            {
              name: "name",
              label: "Name",
            },
            {
              name: "email",
              label: "Email",
            },
            {
              name: "isAdmin",
              label: "Admin",
              type: "checkbox",
            },
          ]}
        />
      </div>
    </View>
  );
};
